export const uk = {
    emptyMessage: 'Введите значение',
    integerMessage: 'Значение должно быть целым числом',
    nanMessage: 'Значение должно быть числом',
    tooBig: 'Слишком большое значение. Допустимые значения от {minLimit} до {maxLimit}',
    tooLittle: 'Слишком маленькое значение. Допустимые значения от {minLimit} до {maxLimit}'
};
